import { Button, Form, Input } from 'antd';
import _ from 'lodash';
import { useState } from 'react';
import { $Formutil, withForm } from 'react-antd-formutil';
import FormItem from 'components/FormItem';
import CountrySelect from 'components/forms/CountrySelect';
import Email from 'components/forms/Email';
import StatesSelect from 'components/forms/StatesSelect';
import TelPhone from 'components/forms/TelPhone';
import { ModalHandler } from 'components/Modal';
import Toast from 'components/Toast';
import API from 'utils/API';
import http from 'utils/http';
import './style.scss';

interface AddContactModalProps extends ModalHandler {
    isEdit?: boolean;
    $formutil: $Formutil<{
        id: string;
        first_name: string;
        last_name: string;
        email: string;
        tel_code: string;
        phone: string;
        relationship: number;
        country: string;
        home_address: string;
        home_address2: string;
        home_city: string;
        home_state_code: string;
        home_postal: string;
    }>;
}

const AddContactModal: React.FC<AddContactModalProps> = ({ isEdit, $formutil, close }) => {
    const { $params, $invalid, $getFirstError, $batchDirty } = $formutil;
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if ($invalid) {
            Toast.show($getFirstError());

            $batchDirty(true);
        } else {
            setLoading(true);

            try {
                if (isEdit) {
                    await http.put(API.CUSTOMER.deleteTrustedPerson($params.id), $params);
                } else {
                    await http.post(API.CUSTOMER.getTrustedPerson(), $params);
                }

                await Toast.show(__('Success!'));
                close();
            } catch (error) {
                Toast.show(error);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <Form className="add-contact-modal" layout="vertical" onFinish={handleSubmit}>
            <h3 className="title">{isEdit ? __('Edit Trusted Contact Person') : __('Add Trusted Contact Person')}</h3>
            <div className="form-info">
                <FormItem
                    className="contact-item"
                    label={__('First Name')}
                    name="first_name"
                    required
                    validMessage={{ required: __('Please enter your first name') }}>
                    <Input placeholder={__('First Name')} />
                </FormItem>
                <FormItem className="contact-item" label={__('Middle Initial (If Applicable)')} name="middle_initial">
                    <Input placeholder={__('Middle Initial')} />
                </FormItem>
                <FormItem
                    className="contact-item"
                    label={__('Last Name')}
                    name="last_name"
                    required
                    validMessage={{ required: __('Please enter your last name') }}>
                    <Input placeholder={__('Last Name')} />
                </FormItem>
                <Email className="contact-item" name="email" label={__('E-mail Address')} disabledValidate={isEdit} />
                <TelPhone
                    className="contact-item"
                    label={__('Phone number')}
                    defaultTelcode={1}
                    disabledValidate={isEdit}
                />
                <FormItem
                    className="contact-item"
                    label={__('Relationship')}
                    name="relationship"
                    required
                    validMessage={{ required: __('Please enter relationship') }}>
                    <Input placeholder={__('Relationship')} />
                </FormItem>
                <h3 className="sub-title">{__('Residential Address')}</h3>
                <CountrySelect className="contact-item" $defaultValue="USA" />
                <FormItem
                    className="contact-item"
                    label={__('Address 1')}
                    name="home_address"
                    required
                    validMessage={{ required: __('Please enter an address') }}>
                    <Input placeholder={__('Address 1')} />
                </FormItem>
                <FormItem className="contact-item" label={__('Address 2(Optional)')} name="home_address2">
                    <Input placeholder={__('Address 2 (optional)')} />
                </FormItem>
                <FormItem
                    className="contact-item"
                    label={__('City')}
                    name="home_city"
                    required
                    validMessage={{ required: __('Please enter a city') }}>
                    <Input placeholder={__('City')} />
                </FormItem>
                {$params.country === 'USA' ? (
                    <StatesSelect className="contact-item" />
                ) : (
                    <FormItem
                        className="contact-item"
                        label={__('State / Province')}
                        name="home_state_code"
                        required
                        validMessage={{ required: __('Please select a state/province') }}>
                        <Input placeholder={__('State / Province')} />
                    </FormItem>
                )}
                <FormItem
                    className="contact-item"
                    label={__('Zip/Postal Code')}
                    name="home_postal"
                    required
                    validMessage={{ required: __('Please enter a zip/postal code') }}>
                    <Input placeholder={__('Zip/Postal Code')} />
                </FormItem>
            </div>
            <div className="btn-box">
                <Button size="large" block loading={loading} disabled={loading} type="primary" htmlType="submit">
                    {__('Submit')}
                </Button>
            </div>
        </Form>
    );
};

export default withForm(AddContactModal);
